import { ActivationStatus } from '@/app/shared/enums';
import { IndividualModel } from '@/app/shared/models';
import { Model } from '@/app/shared/models/model';

export class ActivationModel extends Model {
  public Status!: ActivationStatus;
  public LuckNumber!: string;
  public Created!: Date;
  public Updated!: Date;

  public Individuals: IndividualModel[] = [];

  public Service!: {} & {
    Id: string;
    Name: string;
  };
}
